import React from "react";
import { ButtonGroup, Modal, Spinner } from "react-bootstrap";
import { LedgerReferenceType, LedgerType } from 'src/pages/pto/types';
import Checkbox from "../common/checkbox";
import IconButton from "../common/IconButton";
import './LedgerStatusChange.css';
import { PTOSnapshotType } from "src/pages/pto/types";

export interface IProps {
    ledgerStatusTypes: LedgerReferenceType[] | undefined
    ledgerEntry: LedgerType
    changeType: string
    saving: boolean
    showLedgerStatusChangeModal: boolean
    setShowLedgerStatusChangeModal: Function
    handleLedgerStatusChange: Function
    isOwnPTO: boolean
    ptoData: {
        ledger: Array<LedgerType>;
        pending: Array<number>;
        snapshot: PTOSnapshotType;
    }
    isUpdating: boolean
    showPtoStatusChangeModal?: boolean;
    setShowPtoStatusChangeModal: Function;
}

const LedgerStatusChange: React.FC<IProps> = (props) => {
    const { ledgerEntry, changeType, saving, setShowLedgerStatusChangeModal,
        showLedgerStatusChangeModal, handleLedgerStatusChange, isOwnPTO, ptoData, isUpdating, showPtoStatusChangeModal, setShowPtoStatusChangeModal } = props;
    const [editableEntry, setEditableEntry] = React.useState(ledgerEntry ? { ...ledgerEntry, } : {} as any);

    const closeShowLedgerStatusChange = () => {
        setShowLedgerStatusChangeModal(false);
        setShowPtoStatusChangeModal(false);
    }

    const changeEntryStatus = (newStatus: string) => {
        setEditableEntry({ ...editableEntry, status: newStatus });
    }

    const handleCommentChange = (e: any) => {
        setEditableEntry({ ...editableEntry, [e.target.name]: e.target.value });
    }

    return (
        <Modal show={showLedgerStatusChangeModal || showPtoStatusChangeModal} dialogClassName='ledger-status-change' centered>
            <Modal.Header>
                {changeType === "ledgerChangeType" ? <h3>Ledger Status Change</h3> : changeType === "ptoChangeType" && <h3>PTO Status Change</h3>}
            </Modal.Header>
            <Modal.Body>
                {
                    !isOwnPTO && editableEntry &&
                    <div className="d-flex flex-column  ">
                        <ButtonGroup className="flex-column text-left">
                            {/*!!r-18-cm*/}
                            {/*@ts-ignore*/}
                            <Checkbox
                                label="Requested"
                                isChecked={editableEntry.status === "Pending"}
                                onChange={() => changeEntryStatus("Pending")}
                            >
                                Requested
                            </Checkbox>
                            {/*!!r-18-cm*/}
                            {/*@ts-ignore*/}
                            <Checkbox
                                label="Approve"
                                isChecked={editableEntry.status === "Approved"}
                                onChange={() => changeEntryStatus("Approved")}
                            >
                                Approve
                            </Checkbox>
                            {/*!!r-18-cm*/}
                            {/*@ts-ignore*/}
                            <Checkbox
                                name="denied"
                                label="Deny"
                                isChecked={editableEntry.status === "Denied"}
                                onChange={() => changeEntryStatus("Denied")}
                            >
                                Deny
                            </Checkbox>
                        </ButtonGroup>
                        <div className="d-flex flex-column col-12 mt-4">
                            <strong>Comments</strong>
                            <textarea name="managerComment" onChange={handleCommentChange} style={{ minHeight: 100, minWidth: "50%" }} value={editableEntry.managerComment || ""}>
                            </textarea>
                        </div>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <IconButton disabled={saving} onClick={() => closeShowLedgerStatusChange()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
                {
                    isUpdating ?
                        <Spinner size="sm" animation="border" />
                        : <IconButton disabled={saving} showSpinner={saving} onClick={(e) => handleLedgerStatusChange(editableEntry, ptoData)} buttonClassName="action-text" icon="save">
                            Save
                        </IconButton>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default LedgerStatusChange;